import React, { useEffect, useRef, useState } from "react";
import "./NearbyPlaces.css";



export default function NearbyPlaces() {
  const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
  const cardRefs = useRef([]);
  const [visibleCards, setVisibleCards] = useState([]);
const places = [
  {
    title: "Ladli Ji Dham, Barsana",
    img: "barsana mandir.jpg",
    distance: "5 minutes away",
  },
  {
    title: "Govardhan",
    img: "goverdhan.png",
    distance: "20 minutes away",
  },
  {
    title: "Shri Anjan Bihari Ji Temple",
    img: "gallery2.jpg",
    distance: "2 minutes away",
  },
  {
    title: "Vrindavan",
    img: "Vrindavan.png",
    distance: "35 minutes away",
  },
  {
    title: "Mathura",
    img: "Mathura.jpg",
    distance: "45 minutes away",
  },
  
  
];
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const idx = Number(entry.target.dataset.index);
            setVisibleCards((prev) =>
              prev.includes(idx) ? prev : [...prev, idx]
            );
          }
        });
      },
      { threshold: 0.3 }
    );

    cardRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="nearby-section">
      <div className="container-fluid gigi">
        <div className="header">
          {/* <span id="subtitle"> Places</span> */}
          <h2 className="high-light">Highlights Near by</h2>
        </div>
        <div className="cards">
          {places.map((place, idx) => (
            <div
              key={idx}
              data-index={idx}
              ref={(el) => (cardRefs.current[idx] = el)}
              className={`cardi ${visibleCards.includes(idx) ? "animate" : ""}`}
            >
              <div className="image-wrapper">
                <img
                  src={`${IMAGE_BASE_URL}/${place.img}`}
                  alt={place.title}
                  className="image-fluid"
                />
                <div className="gradient-overlay" />
              </div>
              <div className="info">
                <h3>{place.title}</h3>
                <span>{place.distance}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
